import query from './ducks/query';

export const {
  updateLimit,
  updatePage,
  updateSort,
  updateFilters,
  removeFilters,
} = query.actions;
